import { v4 as uuidv4 } from 'uuid';
export const mapUploadedFilesToVariantImages = ({ results, filters, }) => {
    const items = [];
    results.forEach(({ result, uploadToAllVariants }) => {
        if (uploadToAllVariants) {
            const combinations = getImageTagsCombinations(filters);
            combinations.forEach((combination) => {
                items.push({
                    id: uuidv4(),
                    url: result.files.length ? result.files[0].uri : '',
                    tags: combination,
                    position: 0,
                });
            });
        }
        else {
            items.push({
                id: uuidv4(),
                url: result.files.length ? result.files[0].uri : '',
                tags: filters.map((filter) => ({ type: filter.tag, name: filter.value })),
                position: 0,
            });
        }
    });
    return items;
};
function getImageTagsCombinations(filters) {
    return filters.reduce((acc, filter) => {
        if (acc.length === 0) {
            return filter.options.map((option) => [
                {
                    type: filter.tag,
                    name: option.value,
                },
            ]);
        }
        return acc.flatMap((combination) => filter.options.map((option) => [
            ...combination,
            {
                type: filter.tag,
                name: option.value,
            },
        ]));
    }, []);
}
